module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plasticMulch":"Plastic Mulch"},"es":{"plasticMulch":"Emplasticado"},"sw":{"plasticMulch":"Plastiki Mulch"}}')
  delete Component.options._Ctor
}
